export const showDate = (date) => {
  if (date) {
    return date;
  } else {
    const today = new Date().toISOString().slice(0, 10);
    return today;
  }
};
export const reducedCalc = (data = [], field = '') => {
  const qty = data.reduce((acc, cum) => {
    acc += cum[field];
    return acc;
  }, 0);
  return qty;
};

export const sortingByName = ({ sortBy, data, order }) => {
  data.sort((a, b) => {
    const nameA = a[sortBy]?.toString().toLowerCase() || "N/A";
    const nameB = b[sortBy]?.toString().toLowerCase() || "N/A";

    // Handle N/A cases
    if (nameA === "n/a" && nameB !== "n/a") return 1;
    if (nameB === "n/a" && nameA !== "n/a") return -1;
    if (nameA === "n/a" && nameB === "n/a") return 0;

    if (nameA < nameB) return order ? 1 : -1;
    if (nameA > nameB) return order ? -1 : 1;
    return 0;
  });
  return data;
};

export const sortingByValue = ({ sortBy, data, order, zeroFirst = false }) => {
  const [sortBy1, sortBy2] = sortBy;

  data.sort((a, b) => {
    const valueA = sortBy.length > 1
      ? a[sortBy1] - a[sortBy2]
      : a[sortBy1];
    const valueB = sortBy.length > 1
      ? b[sortBy1] - b[sortBy2]
      : b[sortBy1];

    // Handle N/A (or non-numeric) cases
    if (isNaN(valueA) || valueA === "N/A") return 1;
    if (isNaN(valueB) || valueB === "N/A") return -1;

    // Special handling for zero values when zeroFirst is true and ascending order
    if (zeroFirst && order === 0) {
      if (valueA === 0 && valueB !== 0) return -1;
      if (valueB === 0 && valueA !== 0) return 1;
    }

    return order ? valueB - valueA : valueA - valueB;
  });
  return data;
};

export const getSortingArray = ({ column, data, compiler }) => {
  if (Array.isArray(data) && data.length) {
    let newData = compiler(data);
    let dataField = column.dataField[0];
    let valueArray = newData
      .map((obj) => {
        return obj[dataField];
      })
      .reduce((acc, val) => {
        if (typeof val === 'string' && val.length > 0) {
          let formattedVal = val[0]?.toUpperCase() + val.slice(1).replaceAll('_', ' ');
          if (!acc.includes(formattedVal)) {
            acc.push(formattedVal);
          }
        }
        return acc;
      }, [])
      .sort((a, b) => (a < b ? -1 : 1));
    return valueArray;
  }
};

export const sortingBySize = ({ sortBy, data, order }) => {
  const sizeOrder = {
    'xxs': 1,
    'xs': 2,
    's': 3,
    'm': 4,
    'l': 5,
    'xl': 6,
    'xxl': 7,
    '2xl': 7,
    'xxxl': 8,
    '3xl': 8,
    '4xl': 9,
    '5xl': 10,
    '6xl': 11,
  };

  data.sort((a, b) => {
    const sizeA = a[sortBy]?.toString().toLowerCase().trim() || "n/a";
    const sizeB = b[sortBy]?.toString().toLowerCase().trim() || "n/a";

    if (sizeA === "n/a" && sizeB !== "n/a") return 1;
    if (sizeB === "n/a" && sizeA !== "n/a") return -1;
    if (sizeA === "n/a" && sizeB === "n/a") return 0;

    const priorityA = sizeOrder[sizeA] ?? Infinity;
    const priorityB = sizeOrder[sizeB] ?? Infinity;

    return order ? priorityB - priorityA : priorityA - priorityB;
  });

  return data;
};

export function capitalize(input) {
  if (typeof input !== 'string' || input.length === 0) {
    return '';
  }
  return input.charAt(0).toUpperCase() + input.slice(1);
}

export const sortingByDate = ({ sortBy, data, order }) => {
  data.sort((a, b) => {
    const dateA = a[sortBy] && a[sortBy] !== "N/A"
      ? new Date(a[sortBy]).getTime()
      : null;
    const dateB = b[sortBy] && b[sortBy] !== "N/A"
      ? new Date(b[sortBy]).getTime()
      : null;

    // Handle N/A cases
    if (dateA === null && dateB !== null) return 1;
    if (dateB === null && dateA !== null) return -1;
    if (dateA === null && dateB === null) return 0;

    return order ? dateA - dateB : dateB - dateA;
  });
  return data;
};

export const capitalizeWords = (str) => {
  if (typeof str !== 'string') return '';
  return str
    .toLowerCase()
    .replaceAll('_', ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
export const BoxSizeFormat = (str) => {
  return str.replaceAll('_', ' X ');
};
